module.exports = __webpack_public_path__ + "img/th.bcc03a3c.svg";